import { Component, OnInit } from '@angular/core';
import { FavouritesService } from 'src/app/services/favourites/favourites.service';

@Component({
    selector: 'app-favourites-slider',
    templateUrl: './favourites-slider.component.html',
    styleUrls: ['./favourites-slider.component.scss'],
    standalone: false
})
export class FavouritesSliderComponent implements OnInit {

  favourites = [];
  
  slickConfig = {
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 5 * 1000, // 5 seconds
    centerMode: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 3,
          centerMode: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true, 
          arrows: true
        }
      }
    ]
  };

  constructor(
    private favouritesService: FavouritesService,
  ) { }

  ngOnInit() {
    this.favouritesService.favourites$.subscribe(favourites => {
      this.favourites = [];

      if (favourites['venues'].length > 0) {
        favourites['venues'].forEach(venue => {
          this.favourites.push({
            img_url: venue.banner_url,
            text: venue.name,
            type: 'venue',
            id: venue.slug,
          })
        });
      }
      
      if (favourites['services'].length > 0) {
        favourites['services'].forEach(service => {
          this.favourites.push({
            img_url: service.image_url,
            text: service.name + ' @ ' + service.venue_name,
            type: 'service',
            id: service.id,
          })
        });
      }
    })
  }

  slickInit(e) {
    // console.log('slick initialized');
  }

  breakpoint(e) {
    // console.log('breakpoint');
  }

  afterChange(e) {
    // console.log('afterChange');
  }

  beforeChange(e) {
    // console.log('beforeChange');
  }
}
